module.exports = __webpack_public_path__ + "img/Samenwerken zweethut maken.3920bf06.jpg";